import { DIMENSION_HALF_LINE_TERMINATOR, DIMENSION_STROKE_WIDTH } from '@rta/rta-blueprint-library';

import { getDimensionMeasurement } from '@r-core/helpers';
import { TRIM_DIMENSION_LABEL_GAP, TRIM_DIMENSION_LABEL_MARGIN } from './helpers';
import { useSvgBox } from '@r-hooks';

type RenderFlatTrimDimensionProps = {
	length: number;
	centerX: number;
	lineY: number;
	labelBelow: boolean;
	fontSize: number;
	includeLabelBox: boolean;
	useFractions: boolean;
};

// DimensionLine rotates its label to vertical on spans this short, so the cramped 3" and 1.5"
// trim dimensions are drawn flat here with the label pushed clear of the geometry
export const RenderFlatTrimDimension = (props: RenderFlatTrimDimensionProps): React.ReactElement => {
	const { length, centerX, lineY, labelBelow, fontSize, includeLabelBox, useFractions } = props;

	const { box, refText } = useSvgBox(fontSize);

	const startX = centerX - (length / 2);
	const endX = centerX + (length / 2);
	const labelY = lineY + ((labelBelow ? 1 : -1) * ((box.height / 2) + TRIM_DIMENSION_LABEL_GAP));

	return (
		<g>
			<line x1={startX} y1={lineY} x2={endX} y2={lineY} stroke="black" strokeWidth={DIMENSION_STROKE_WIDTH} />
			<line x1={startX} y1={lineY - DIMENSION_HALF_LINE_TERMINATOR} x2={startX} y2={lineY + DIMENSION_HALF_LINE_TERMINATOR}
				stroke="black" strokeWidth={DIMENSION_STROKE_WIDTH} />
			<line x1={endX} y1={lineY - DIMENSION_HALF_LINE_TERMINATOR} x2={endX} y2={lineY + DIMENSION_HALF_LINE_TERMINATOR}
				stroke="black" strokeWidth={DIMENSION_STROKE_WIDTH} />
			{includeLabelBox && <rect
				x={centerX - (box.width / 2) - TRIM_DIMENSION_LABEL_MARGIN}
				y={labelY - (box.height / 2)}
				width={box.width + (TRIM_DIMENSION_LABEL_MARGIN * 2)}
				height={box.height}
				fill="white" stroke="black" strokeWidth={DIMENSION_STROKE_WIDTH / 3} rx="0.5" ry="0.75" opacity={0.7}
			/>}
			<text ref={refText} x={centerX} y={labelY} textAnchor="middle" dominantBaseline="middle"
				fill="black" fontSize={fontSize} className="rta-designer-component-measure rta-noselect">
				{getDimensionMeasurement(length, useFractions)}&quot;
			</text>
		</g>
	);
};
